import { ChangeEventHandler } from "react";
import { RegisterOptions } from "react-hook-form";
import { range } from "lodash";

type YearOfBirthFieldProps = {
  now: Date;
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};
export const YearOfBirthField: React.FC<YearOfBirthFieldProps> = ({ now, register, errors, onChange }) => (
  <div className="field">
    <label>
      <span className="label">生まれ年</span>
      <select
        data-test="input-year_of_birth"
        {...register("yearOfBirth", {
          required: true,
        })}
        onChange={onChange}
      >
        {range(now.getFullYear() - 100, now.getFullYear()).map((year) => {
          return <option key={year} value={year}>{`${year}年`}</option>;
        })}
      </select>
      {errors.yearOfBirth && <span className="sub red">生まれ年を入力してください。</span>}
      <span className="sub">あとで変更できません</span>
    </label>
  </div>
);
